import React from "react";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";

import { TableHeadCell } from "../types";

interface SkeletonTableRowsProps<T> {
  columns: TableHeadCell<T>[];
  rowCount?: number;
  withActions?: boolean;
}

const SkeletonTableRows = <T extends { id: string }>(
  props: SkeletonTableRowsProps<T>
) => {
  const { columns, rowCount = 5, withActions } = props;

  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`}>
          {columns.map(({ width }, colIndex) => (
            <TableCell
              sx={{ width }}
              key={`skeleton-cell-${rowIndex}-${colIndex}`}
            >
              <Skeleton animation="wave" />
            </TableCell>
          ))}
          {withActions && (
            <TableCell
              sx={{ width: "5%" }}
              key={`skeleton-actions-${rowIndex}`}
              align="right"
            >
              <Skeleton animation="wave" />
            </TableCell>
          )}
        </TableRow>
      ))}
    </>
  );
};

export default SkeletonTableRows;
